import React from 'react'
import { UpcomingEventDataTable } from './LiveEvents/UpcomingEvents/UpcomingEventDataTable'
import { RequestedEventDataTable } from './LiveEvents/RequestedEvents/RequestedEventDataTable'
import { Calendar } from '~/components/coach_services/OutplacementBenefits/Calendar'
import { useCoachDashboard } from './CoachDashboardProvider'
import { Button } from '~/lib/ui/button'
import ColorKeyDialog from './LiveEvents/ColorKeyDialog'
import { apiGet } from '~/util/api'
import { useQuery } from '@tanstack/react-query'

const LiveEvents = () => {
  const { setShowColorKeyDialog } = useCoachDashboard()

  const queryFn = () =>
    apiGet('/coach/upcoming_calendar_events').then((response) => response.data)

  const { data, error } = useQuery({
    queryKey: ['calendarEvents'],
    queryFn,
  })

  if (error) {
    console.error('Error fetching data:', error)
    return <div>Error loading data</div>
  }

  return (
    <div className="space-y-4">
      <div className="space-y-4">
        <div className="subtitle">Your Upcoming Workshops & Webinars</div>
        <UpcomingEventDataTable />
      </div>
      <div className="space-y-4">
        <div className="subtitle">Requested Upcoming Workshops & Webinars</div>
        <RequestedEventDataTable />
      </div>
      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <div className="subtitle">Live Event Calendar</div>
          <ColorKeyDialog />
          <Button
            variant="link"
            size="sm"
            className="!rounded-full !px-4 !py-2"
            onClick={() => setShowColorKeyDialog(true)}
          >
            Color Code Key
          </Button>
        </div>
        <Calendar
          calendar_events={data.events}
          homePageDisplay={false}
          opRedesign={true}
          coachDashboardDisplay={true}
        />
      </div>
    </div>
  )
}
export default LiveEvents
